module.exports = __webpack_public_path__ + "img/google-calendar.810012a1.png";